import React, { useState, useEffect } from 'react';
import './TopBar.css';

function TopBar({ onMenuToggle }) {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    return `${date.getMonth() + 1}月${date.getDate()}日(${weekdays[date.getDay()]})`;
  };

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <header className="top-bar">
      <div className="top-bar-content">
        <div className="top-bar-left">
          <button
            className="top-bar-hamburger"
            type="button"
            onClick={onMenuToggle}
            aria-label="メニューを開く"
          >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
              <path d="M11 14h18M11 20h18M11 26h18" stroke="#00cc5b" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
          <p className="top-bar-date">{formatDate(currentDateTime)}</p>
          <p className="top-bar-time">{formatTime(currentDateTime)}</p>
        </div>
      </div>
    </header>
  );
}

export default TopBar;
